const BOOKING_URL = 'https://www.booking.com/hotel/si/gostilna-marta.sl.html';

export default function RoomsBooking() {
  return (
    <section id="booking" className="relative bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-4xl mx-auto">
          <div className="relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 px-6 py-12 md:px-14 md:py-16 text-center">
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-primary-100/50 blur-2xl pointer-events-none" />
            <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full bg-accent-100/50 blur-2xl pointer-events-none" />

            <div className="relative">
              <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-4">
                REZERVACIJA
              </p>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-4">
                Rezerviraj svoj oddih
              </h2>
              <p className="font-body text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed mb-10">
                Razpoložljivost in rezervacijo preveri na platformi Booking.com. Izberi termin in
                oddaj rezervacijo v nekaj korakih.
              </p>

              <div className="flex flex-col items-center gap-6">
                <div
                  className="inline-flex items-center rounded-md px-5 py-3"
                  style={{ backgroundColor: '#003580' }}
                  aria-label="Booking.com"
                >
                  <span className="relative font-body font-semibold text-white text-lg md:text-xl tracking-tight">
                    Booking.com
                    <span
                      className="absolute -right-2 -top-1 w-2 h-2 rounded-full"
                      style={{ backgroundColor: '#febb02' }}
                    ></span>
                  </span>
                </div>

                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 text-xs md:text-sm font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm"
                >
                  <i className="ri-external-link-line"></i>
                  ODPRI NA BOOKING.COM
                </a>

                <p className="font-body text-xs text-foreground-500">
                  Odprlo se bo v novem zavihku.
                </p>
              </div>

              <div className="mt-10 md:mt-12 pt-8 md:pt-10 border-t border-background-200/70 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 text-left">
                <div>
                  <p className="font-label text-[10px] tracking-extra-wide uppercase text-accent-600 mb-2">
                    Pokliči nas
                  </p>
                  <a
                    href="tel:+38627130060"
                    className="flex items-center gap-2 font-body text-sm text-foreground-700 hover:text-primary-700 transition-colors duration-300 cursor-pointer"
                  >
                    <i className="ri-phone-line text-primary-500"></i>
                    02 713 00 60
                  </a>
                  <a
                    href="tel:+38641331990"
                    className="flex items-center gap-2 font-body text-sm text-foreground-700 hover:text-primary-700 transition-colors duration-300 mt-2 cursor-pointer"
                  >
                    <i className="ri-smartphone-line text-primary-500"></i>
                    041 331 990
                  </a>
                </div>
                <div>
                  <p className="font-label text-[10px] tracking-extra-wide uppercase text-accent-600 mb-2">
                    Naslov
                  </p>
                  <p className="font-body text-sm text-foreground-600 leading-relaxed">
                    Cvetkovci 50
                    <br />
                    2273 Podgorci, Slovenija
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}